import axios from 'axios'
import {UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/user/sign-in`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export async function login(email: string, password: string) {
  // console.log('Hello from login')
  return await axios.post<UserModel>(LOGIN_URL, {
    emailId: email,
    password,
  })
}

// Server should return AuthModel
export function register(params: {
  emailId: string
  name: string
  password: string
  role: string
  region: string
  address: string
  countryCode: string
  mobile: string
  isSuperAdmin: boolean
}) {
  return axios.post(REGISTER_URL, {
    ...params,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export async function requestPassword(email: string) {
  return await axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export async function getUserByToken(token: string) {
  return await axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
